(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('FiltroRelatorioService', FiltroRelatorioService);

  function FiltroRelatorioService($http, ngsalConfig) {

    var service = {
      getRelatoriosByPromotorAndPeriodoAndSituacao: getRelatoriosByPromotorAndPeriodoAndSituacao,
      visualizarRelatorio: visualizarRelatorio,
      carregaSituacoesPossiveis: carregaSituacoesPossiveis
    };

    return service;

    function getRelatoriosByPromotorAndPeriodoAndSituacao(pessDk, periodo, situacao) {

      let endpoint = `/mgp-corregedoria/api/${ngsalConfig.apiVersion}/promotor/${pessDk}/periodo/${periodo}`;
      endpoint += `?situacao=${situacao}`;

      let promise = $http.get(endpoint).then( (response) => {
        return response.data;
      });

      return promise;
    }

    function visualizarRelatorio(relatorio, orgao, periodo, pessDk) {

      var param = {
        orgaoDk : orgao.id,
        nomeOrgao : orgao.nome,
        anoMes : periodo,
        relDk : relatorio.id,
        nome : relatorio.nome,
        relMensalDK: relatorio.relMensalDK,
        glosaTotal: relatorio.glosaTotal
      };

      var promise = $http.put(`/mgp-corregedoria/api/${ngsalConfig.apiVersion}/promotor/${pessDk}/relatorio/${relatorio.relMensalDK}`, param)
      .then(function (response) {
        return response.data;
      });

      return promise;

    }

    function carregaSituacoesPossiveis() {

      let endpoint = `/mgp-corregedoria/api/${ngsalConfig.apiVersion}/relatorio/filtro/situacao`;

      var promise = $http.get(endpoint)
        .then( (response) => {
          return response.data;
      });

      return promise;
    }
  }
})();
